module.exports = __webpack_public_path__ + "img/mgw-bg-mgw-bottomcoins.4edceec1.png";